import { Injectable } from '@angular/core'
import { ModalPositionService } from '@helios/user-preferences'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { SessionModalResponse } from '../../../models/session-action.model'
import { UncommittedChangesDetectedModalComponent } from './uncommitted-changes-detected-modal.component'

@Injectable({
  providedIn: 'root',
})
export class UncommittedChangesDetectedModalService {
  constructor(
    private readonly modalService: NgbModal,
    private readonly modalPositionService: ModalPositionService,
  ) {}

  /** Show/hide modal */
  toggleUncommittedChangesModal(
    accountIds: number[],
    numOfCommands: number,
  ): Promise<SessionModalResponse | undefined> {
    const compKey = 'uncommitted-changes-detected'
    const uniqueId = compKey + '-' + Date.now()
    const modalRef = this.modalService.open(
      UncommittedChangesDetectedModalComponent,
      {
        keyboard: false,
        windowClass: uniqueId,
        beforeDismiss: () => {
          return this.modalPositionService.handleModalPositionSaveOnDismiss(
            uniqueId,
            compKey,
          )
        },
      },
    )
    const component =
      modalRef.componentInstance as UncommittedChangesDetectedModalComponent
    component.accountIds = accountIds
    component.changes = numOfCommands

    this.modalPositionService.handleModalPositionSetup(uniqueId, compKey)

    return modalRef.result.then(
      response => response,
      () => {},
    )
  }
}
